<template>
  <div
    id="app"
    ref="app"
  >
    <navbar ref="navbar" v-if="!$route.meta.noTop"></navbar>
    <agenthead ref="agenthead" v-if="$route.meta.noTop && $route.meta.agentTop"></agenthead>
    <router-view />
    <nav-footer ref="navFooter" v-if="!$route.meta.noTop"></nav-footer>
  </div>
</template>

<script>
import navbar from './public-modules/navbar/index'
import navFooter from './public-modules/footer/index'
import agenthead from './public-modules/agenthead/index'

export default {
  name: 'App',
  data () {
    return {
      screenWidth: 0
    }
  },
  components: {
    navbar,
    navFooter,
    agenthead
  },
  mounted () {
    const that = this
    this.$nextTick(() => {
      this.screenWidth = document.body.clientWidth
      document.documentElement.style.fontSize = this.screenWidth / 20 + 'px'
      window.onresize = () => {
        return (() => {
          window.screenWidth = document.body.clientWidth
          that.screenWidth = window.screenWidth
        })()
      }
    })
  },
  watch: {
    screenWidth (val) {
      this.screenWidth = val
      if (val < 1100) {
        val = 1100
      }
      document.documentElement.style.fontSize = val / 20 + 'px'
    }
  }
}
</script>

<style>
html,
body {
  margin: 0;
}
.body {
  padding-top: 70px;
}
* {
  font-family: 'en', 'jp', sans-serif;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #222;
}
</style>



// WEBPACK FOOTER //
// src/App.vue